/**
 * Les fichiers qu'une personne dépose, avec leur chemin RELATIF dans
 * l'arborescence d'origine (dépôt de reprise, ARTO-129) : un dossier glissé
 * ou choisi garde ses sous-dossiers, `Export/Contacts/carnet.csv`.
 *
 * Les fichiers techniques des systèmes (`.DS_Store`, `Thumbs.db`, doubles
 * AppleDouble `._x`, dossiers `__MACOSX`) ne sont pas des données : ils sont
 * laissés de côté ici plutôt que refusés un à un par l'inventaire.
 */
const TECHNIQUES = new Set(['.ds_store', 'thumbs.db', 'desktop.ini']);
export function estFichierTechnique(chemin) {
    const segments = chemin.split('/');
    const nom = (segments.at(-1) ?? '').toLowerCase();
    return TECHNIQUES.has(nom) || nom.startsWith('._') || segments.some((s) => s === '__MACOSX');
}
function garder(fichiers) {
    return fichiers.filter((choisi) => !estFichierTechnique(choisi.chemin));
}
/** Les fichiers d'un sélecteur (`multiple` ou `webkitdirectory`). */
export function fichiersDuChoix(liste) {
    return garder(Array.from(liste, (fichier) => ({
        fichier,
        chemin: (fichier.webkitRelativePath || fichier.name).replace(/^\/+/, ''),
    })));
}
function lireFichier(entree) {
    return new Promise((resoudre, rejeter) => {
        entree.file(resoudre, rejeter);
    });
}
/** Un dossier se lit par lots (cent entrées au plus chez Chromium) jusqu'au lot vide. */
async function lireDossier(entree) {
    const lecteur = entree.createReader();
    const toutes = [];
    for (;;) {
        const lot = await new Promise((resoudre, rejeter) => {
            lecteur.readEntries(resoudre, rejeter);
        });
        if (lot.length === 0)
            return toutes;
        toutes.push(...lot);
    }
}
async function parcourir(entree, sortie) {
    if (entree.isFile) {
        const fichier = await lireFichier(entree);
        sortie.push({ fichier, chemin: entree.fullPath.replace(/^\/+/, '') });
        return;
    }
    if (entree.isDirectory)
        for (const enfant of await lireDossier(entree))
            await parcourir(enfant, sortie);
}
/**
 * Les fichiers d'un glisser-déposer, dossiers parcourus. Les entrées se lisent
 * PENDANT l'évènement (`webkitGetAsEntry`), le parcours ensuite.
 */
export async function fichiersDuGlisser(transfert) {
    const entrees = Array.from(transfert.items)
        .filter((item) => item.kind === 'file')
        .map((item) => item.webkitGetAsEntry?.() ?? null);
    if (entrees.some((entree) => entree === null))
        return fichiersDuChoix(transfert.files);
    const sortie = [];
    for (const entree of entrees)
        if (entree !== null)
            await parcourir(entree, sortie);
    return garder(sortie);
}
//# sourceMappingURL=collecte.js.map